import React, { useState, useContext } from 'react'
import get from 'lodash/get'
import qs from 'query-string'
import { useQuery } from '@apollo/react-hooks'

import NoData from 'components/NoData'
import Page404 from 'components/Page404'
import Loader from 'components/loaders/Loader'
import {
  GET_MONTHLY_EXPOSURE_REPORT,
  GET_USER_ABSOLUTE_RETURN_PDF,
} from 'modules/Reports/graphql/Queries'
import MonthlyExposureTable from 'modules/Reports/MonthlyExposure/MonthlyExposureTable'
import 'modules/Reports/index.css'
import { GET_USER } from 'modules/Users/graphql/Queries'
import CustomMeta from 'components/CustomMeta'
import { Button, Popover } from 'antd'
import client from 'apollo'
import PdfIcon from 'assets/images/new-images/pdficon.svg'
import { CSVLink } from 'react-csv'
import ExcelIcon from 'assets/images/new-images/excelIcon.svg'
import { DownloadOutlined } from '@ant-design/icons'
import { AppContext } from 'AppContext'
import { canUserDownload, canUserExport } from 'utils/User'

export default function (props) {
  let {
    match: {
      params: { clientCode, pnl, clientId },
    },
    history: {
      location: { search },
    },
  } = props
  const {
    state: { currentUser, isClient, userPermissions },
  } = useContext(AppContext)
  const hasExport = canUserExport(userPermissions || currentUser, isClient)
  const hasDownload = canUserDownload(userPermissions || currentUser, isClient)
  const [pdfLoading, setPdfLoading] = useState(false)
  const parsed = qs.parse(search || {})
  const { strategy = 'ILTS' } = parsed
  
  const {
    data: getUserData,
    loading: getUserLoading,
    error: getUserError,
  } = useQuery(GET_USER, { variables: { id: clientId } })

  const { data, loading, error } = useQuery(GET_MONTHLY_EXPOSURE_REPORT, {
    variables: {
      where: { 
        clientCode, 
        strategy, 
        ii: pnl ? parseInt(pnl) : undefined,
        userName: getUserData?.getUser?.userName,
        strategyCode: getUserData?.getUser?.strategyCode,
      },
    },
    skip: !getUserData?.getUser,
  })

  if (loading || getUserLoading) return <Loader />
  if (error || getUserError) return <Page404 error={error} />
  if (!get(data, 'spMonthlyExposureReport')) return <NoData />
  const {
    spMonthlyExposureReport: [spMonthlyExposureReport],
  } = data

  const generatePDF = async () => {
    try {
      setPdfLoading(true)
      await client
        .query({
          query: GET_USER_ABSOLUTE_RETURN_PDF,
          variables: {
            data: {
              fileName: `ABSOLUTE-RETURN-${clientCode}`,
              clientCode: clientCode,
              strategy: '1005',
              ii: pnl ? parseInt(pnl) : undefined,
              userName: getUserData?.getUser?.userName,
              strategyCode: getUserData?.getUser?.strategyCode,
            },
          },
          fetchPolicy: 'network-only',
        })
        .then((res) => {
          if (res?.data?.getUserPerformancePDFs) {
            window.open(res.data.getUserPerformancePDFs, '_blank')
          }
        })
    } catch (error) {
      console.error('Error generating PDF:', error)
    } finally {
      setPdfLoading(false)
    }
  }
  const content = (
    <div>
      {hasDownload && (
        <Button
          onClick={generatePDF}
          loading={pdfLoading}
          style={{
            padding: '0px',
            marginBottom: '0px',
            fontSize: '14px',
            fontWeight: '600',
            lineHeight: '24px',
            textAlign: 'left',
            color: ' #000',
            cursor: 'pointer',
            border: 'none',
          }}
        >
          <img src={PdfIcon} style={{ marginRight: '10px' }} alt='pdf' /> PDF
        </Button>
      )}
      {hasDownload && hasExport && <br />}
      {hasExport && (
        <CSVLink
          data={spMonthlyExposureReport}
          filename={`ABSOLUTE-RETURN-${clientCode}.csv`}
          className='csv-btn'
          onClick={(e) => e.stopPropagation()}
        >
          <Button
            style={{
              padding: '0px',
              marginBottom: '0px',
              fontSize: '14px',
              fontWeight: '600',
              lineHeight: '24px',
              textAlign: 'left',
              color: '#000',
              cursor: 'pointer',
              border: 'none',
            }}
          >
            <img src={ExcelIcon} style={{ marginRight: '10px' }} alt='excel' />{' '}
            CSV
          </Button>
        </CSVLink>
      )}
    </div>
  )
  return (
    <>
      <CustomMeta title='Monthly Exposure' />
      {(hasExport || hasDownload) && (
        <div className='download_report_container'>
          <Popover content={content} placement='bottom' trigger='click'>
            <div className='container_Export_Popover'>
              <Button>
                Export{' '}
                <DownloadOutlined color='#AF0000' style={{ fontSize: '16px' }} />
              </Button>
            </div>
          </Popover>
        </div>
      )}
      <div className='report-table-wrapper' id='MONTHLY-EXPOSURE-REPORT-PDF'>
        <MonthlyExposureTable
          reportData={spMonthlyExposureReport}
          ClientCode={clientCode}
          user={getUserData}
        />
      </div>
    </>
  )
}
